import React from 'react';
import DistributorTable from './DistributorTable';


function DistributorList() {
    return (
        <div className="bg-white rounded-lg shadow w-full h-full overflow-auto p-4">
            <DistributorTable />
        </div>
     );
}

export default DistributorList;